import axiosInstance from "@/config/axios";

const getDashboard = async (
	companyId: string,
	selectedEndYear: number,
	selectedStartYear: number,
) => {
	const cleanedId = companyId.replace(/^"(.+)"$/, "$1");

	const configs = {
		params: {
			companyId: cleanedId,
			endDate:
				selectedEndYear === 1111 ? undefined : `${selectedEndYear}-01-01`,
			startDate:
				selectedStartYear === 1111 ? undefined : `${selectedStartYear}-01-01`, // too
		},
	};
	try {
		const response = await axiosInstance.get("/reports/dashboard", configs);
		return response.data.data; // Return the data property
	} catch (error) {
		console.error("Error fetching dashboard data:", error);
		throw error;
	}
};

export { getDashboard };
